import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarTypes } from 'src/app/core/_enums/snackbar.types';
import { AgencyService } from 'src/app/core/_services/agency.service';
import { AuthService } from 'src/app/core/_services/auth.service';
import { ProjectService } from 'src/app/core/_services/project.service';
import { SnackbarService } from 'src/app/core/_services/snackbar.service';
import { SpinnerOverlayService } from 'src/app/core/_services/spinner.overlay.service';

export class ShareProjectDialogData {
  projectIds: string[] = [];
  shareType: string = '';
  agencyId?: string;
  selectedAgenciesIds: string[] = [];
  selectedAgencies: AgencySharing[] = [];
}

class AgencySharing {
  agencyId?: string;
  displayName?: string;
  selected: boolean = false;
  filtered: boolean = false;
}

@Component({
  selector: 'app-dialog-select-eu-share',
  templateUrl: './dialog-share-project.component.html',
  styleUrls: ['./dialog-share-project.component.scss']
})
export class DialogShareProjectComponent {
  dialogData: ShareProjectDialogData = new ShareProjectDialogData();
  currentUserId?: string;
  // agencies: Agency[] = [];
  // filteredAgencies: Agency[] = [];
  agencies: AgencySharing[] = [];
  filteredAgencies: AgencySharing[] = [];
  agencies_filter_str: string = '';
  hasBeSelectionChanged: boolean = false;
  dbSelectedAgencies: string[] = [];

  ngOnInit() {
    this.currentUserId = this.authService.userValue.userId;
  }

  constructor(
    public shareDialogRef: MatDialogRef<DialogShareProjectComponent>,
    private spinnerService: SpinnerOverlayService,
    private agencyService: AgencyService,
    private authService: AuthService,
    private snackbarService: SnackbarService,
    private projectService: ProjectService,
    private translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data) {
      this.initialize(data);
    }
  }

  initialize(data: any) {
    this.dialogData.projectIds = data.projectIds;
    this.projectService.getAgencyAssociations(data.projectIds[0]).subscribe((associations) => {
      associations.forEach((a) => {
        if (!this.dialogData.selectedAgenciesIds.includes(a.agencyId)) {
          this.dialogData.selectedAgenciesIds.push(a.agencyId);
          this.dbSelectedAgencies.push(a.agencyId);
        }
      });

      // code temporaire pour harger les agences tout de suite
      // à retirer quand la fonctionnalité copie de projet pour partage à l'extérieur sera implémentée
      this.dialogData.shareType = 'be';
      this.loadAgencies();
    });
  }

  loadAgencies() {
    if (this.agencies.length == 0) {
      this.spinnerService.show();
      this.agencyService.getAll().subscribe(
        (arr) => {
          if (arr) {
            // this.agencies = arr;
            // this.filteredAgencies = arr;
            this.agencies = arr.map((a) => ({
              agencyId: a.agencyId,
              displayName: a.displayName,
              selected: this.dialogData.selectedAgenciesIds.some((id) => id === a.agencyId),
              filtered: false
            }));
            this.filteredAgencies = this.agencies;
          }
          this.spinnerService.hide();
        },
        (error) => {
          this.snackbarService.open(SnackbarTypes.error);
          this.spinnerService.hide();
        },
        () => {
          this.spinnerService.hide();
        }
      );
    }
  }

  filterAgencies(target: any) {
    if (target?.value?.length > 0) {
      this.filteredAgencies.forEach((a) => (a.filtered = a.displayName ? !a.displayName.toLocaleLowerCase().includes(target.value.toLocaleLowerCase()) : false));
    } else {
      this.filteredAgencies.forEach((a) => (a.filtered = false));
    }
  }

  isAgencySelected(agencyId?: string) {
    return this.dialogData.selectedAgenciesIds.some((id) => id === agencyId);
  }

  onBeSelectionChange(selectedBe: string[]) {
    // let selectedIds = this.dialogData.selectedAgencies.filter(a => a.agencyId).map(a => a.agencyId!.toString());
    //let selectedIds = selectedBe.map((be, index) => { return be.agencyId!; });
    let selectedIds = selectedBe;
    if (!selectedIds.every((id, index) => this.dbSelectedAgencies.includes(id))) {
      this.hasBeSelectionChanged = true;
      return;
    }
    if (!this.dbSelectedAgencies.every((id, index) => selectedIds.includes(id))) {
      this.hasBeSelectionChanged = true;
      return;
    }

    this.hasBeSelectionChanged = false;
  }

  canShare() {
    switch (this.dialogData.shareType) {
      case 'be':
        return this.hasBeSelectionChanged;
        break;
      case 'eu':
        break;
      default:
    }
  }

  onClickBack() {
    this.shareDialogRef.close();
  }

  onClickShare() {
    switch (this.dialogData.shareType) {
      case 'be':
        this.spinnerService.show();
        // let selectedIds = this.dialogData.selectedAgencies.filter(a => a.agencyId).map(a => a.agencyId!.toString());
        let selectedIds = this.dialogData.selectedAgenciesIds;
        // Si on n'a fait aucun changement alors le tableau dialogData.selectedAgencies est vide
        // Problème => l'appel à setAgencyAssociations avec un tableau vide supprimera tous les partages de ce projet
        //    à d'autres agences
        // Pour empêcher ça, si on n'a pas fait de changement alors on appelle setAgencyAssociations avec le tableau
        //    d'origine dialogData.selectedAgenciesIds
        if (selectedIds.length === 0) {
          selectedIds = this.dialogData.selectedAgenciesIds;
        }

        if (this.dialogData.projectIds.length > 1) {
          this.projectService.shareProjectsToAgencies(this.dialogData.projectIds, selectedIds).subscribe(
            (result) => {
              this.snackbarService.open(SnackbarTypes.share, this.translate.instant(this.dialogData.projectIds.length > 1 ? 'success_projects_shared' : 'success_project_shared'));
              this.shareDialogRef.close(this.dialogData.selectedAgenciesIds);
            },
            (error) => {
              this.snackbarService.open(SnackbarTypes.error);
              this.spinnerService.hide();
            },
            () => {
              this.spinnerService.hide();
            }
          );
        } else {
          this.projectService.setAgencyAssociations(this.dialogData.projectIds[0], selectedIds).subscribe(
            (result) => {
              this.snackbarService.open(SnackbarTypes.share, this.translate.instant('success_project_shared'));
              this.shareDialogRef.close(this.dialogData.selectedAgenciesIds);
            },
            (error) => {
              this.snackbarService.open(SnackbarTypes.error);
              this.spinnerService.hide();
            },
            () => {
              this.spinnerService.hide();
            }
          );
        }
        break;
      case 'eu':
        break;
      default:
      //console.log("Type de partage non géré");
    }
  }
}
